<template>
    <v-container fluid>
        <v-card class="pb-2 mb-3">
            <v-card-title>{{ $t("AzureAISettings") }}</v-card-title>
            <v-card-text>
                <v-row justify="center" align="center" v-if="loading">
                    <div class="text-center">
                        <div>
                            <v-progress-circular class="my-4" :size="50" width="5" color="primary"
                                indeterminate></v-progress-circular>
                        </div>
                        <p class="display-1">{{ $t("Loading") }}...</p>
                    </div>
                </v-row>
                <div v-if="!loading">
                    <v-row justify="center" align="center">
                        <v-col cols="5 pb-0" class="text-center">
                            <v-autocomplete v-model="prebuiltModelID" :items="models" :label="$t('DocumentType')"
                                item-text="modelId" item-value="modelId" @change="getModelFields()">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    <h4>
                                        {{ $t("Field") }}
                                    </h4>
                                </th>
                                <th class="text-left">
                                    <h4>
                                        {{ $t("ProviderFields") }}
                                    </h4>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!loadingData" v-for="(item, index) in contentTypeFields" :key="index">
                                <td class="pa-2 pl-4">
                                    <h4 class="font-weight-regular" v-if="item">{{ item.IsRequired ? `${item.Name} *` :
                                        item.Name}}</h4>
                                </td>
                                <td class="text-left">
                                    <prebuilt-config-component ref="prebuiltsComponent" :item="item"
                                        :model-fields="modelFields" :result-paths="[...resultPaths]"
                                        :config-object="configObject"
                                        @getFieldSetting="buildFieldSetting"></prebuilt-config-component>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <v-row justify="center" align="center" v-if="loadingData">
                        <div class="text-center">
                            <div>
                                <v-progress-circular class="my-4" :size="50" width="5" color="primary"
                                    indeterminate></v-progress-circular>
                            </div>
                            <p class="display-1">{{ $t("Loading") }}...</p>
                        </div>
                    </v-row>
                    <div>
                        <v-col class="text-right" align-self="center">
                            <v-btn @click="saveSettings()" color="primary">
                                {{ $t("Save") }}
                            </v-btn>
                            <v-btn @click="cancel()">
                                {{ $t("Cancel") }}
                            </v-btn>
                        </v-col>
                    </div>
                </div>
            </v-card-text>

        </v-card>
    </v-container>
</template>
<script>
import DocumentIntelligenceProvidersService from "@/services/DocumentIntelligenceProvidersService.js";
import ModelFields from "@/ecm/models/contentType/documentIntelligence/ModelFields.js";
import DocumentIntelligenceProvidersSettings from "@/ecm/models/contentType/documentIntelligence/DocumentIntelligenceProvidersSettings.js";
import PrebuiltConfigComponent from "@/components/administration/contentType/documentIntelligence/azureAI/PrebuiltConfigComponent.vue";
import Utils from "@/ecm/common/Utils.js";
import ContentTypeService from "@/services/ContentTypeService";

export default {
    components: {
        PrebuiltConfigComponent
    },
    props: {


    },

    data() {
        return {
            models: [],
            modelFields: [],
            resultPaths: null,
            contentTypeFields: [],
            contentTypeID: this.$route.params.contentTypeID,
            settingID: parseInt(this.$route.params.settingID),
            prebuiltModelID: {},
            documentIntelligenceProviderSettings: new DocumentIntelligenceProvidersSettings(),
            configObject: [],
            saving: false,
            loading: false,
            loadingData: false,
            PrebuiltConfigComponentKey: "prebuiltsComponent",
        };
    },
    async created() {
        this.loading = true;
        await this.getModels();
        await this.getContentTypesFiles(this.contentTypeID);
        await this.getResultPaths();
        if (this.settingID !== 0)
            await this.getSettingsById(this.settingID);
        this.loading = false;
    },
    methods: {
        async getModels() {
            try {
                const result = await DocumentIntelligenceProvidersService.getModels();
                this.models = result.models;
            } catch (error) {
                console.error('Error fetching models:', error);
                this.loading = false;
            }
        },
        async getModelFields() {
            this.loadingData = true;
            try {
                DocumentIntelligenceProvidersService.getFieldsModel(this.prebuiltModelID).then((data) => {
                    this.modelFields = data;
                    this.loadingData = false;
                });
            } catch (error) {
                console.error('Error fetching model fields:', error);
                this.loadingData = false;
            }
        },
        async getContentTypesFiles(contentTypeID) {
            ContentTypeService.getFields(contentTypeID).then((data) => {
                this.contentTypeFields = data;
            })
            .catch((error) => {
                this.loading = false;
            });
        },

        async getResultPaths() {
            DocumentIntelligenceProvidersService.getResultPaths().then((data) => {
                this.resultPaths = data;
            })
            .catch((error) => {
                console.error('Error fetching models:', error);
                this.loading = false;
            });
        },

        cancel() {
            this.goBack();
        },

        goBack() {
            this.$router.push({ path: `/administration/content-type/document-intelligence-settings/${this.contentTypeID}` });
        },
        async saveSettings() {
            let valid = true;
            for (let item of this.$refs[this.PrebuiltConfigComponentKey]) {
                valid = item.validateFields();
                if (!valid)
                    break;
            }

            if (!valid) {
                return;
            }

            if (this.documentIntelligenceProviderSettings.fieldProviders.length === 0) {
                Utils.toast.error(this.$t("NotSelectProviderField"));
                return;
            }

            this.documentIntelligenceProviderSettings.id = parseInt(this.settingID);
            this.documentIntelligenceProviderSettings.contentTypeID = parseInt(this.contentTypeID);
            this.documentIntelligenceProviderSettings.documentIntelligenceProviderID = 1;
            this.documentIntelligenceProviderSettings.configJSON = this.prebuiltModelID;

            this.loading = true;
            await DocumentIntelligenceProvidersService.SaveContentTypeDocumentIntelligenceProviderAsync(this.documentIntelligenceProviderSettings)
                .then((data) => {
                    Utils.toast.success(this.$t("DocumentIntelligenceProviderSettings") + " " + this.$t("OperationSuccess"));
                    this.goBack();
                })
                .catch((error) => {
                    this.loading = false;
                    Utils.toast.error(this.$t(error));
                });
        },

        buildFieldSetting(modifiedFieldSettingsForCode) {
            if (!modifiedFieldSettingsForCode.parentPath) {
                let indexToRemove = this.documentIntelligenceProviderSettings.fieldProviders.findIndex(config => config.fieldCode === modifiedFieldSettingsForCode.fieldCode);
                if (indexToRemove !== -1) {
                    this.documentIntelligenceProviderSettings.fieldProviders.splice(indexToRemove, 1);
                }
            }

            let overwrite = false;
            if (modifiedFieldSettingsForCode.parentPath) {
                for (let field in this.documentIntelligenceProviderSettings.fieldProviders) {
                    if (this.documentIntelligenceProviderSettings.fieldProviders[field].fieldCode === modifiedFieldSettingsForCode.fieldCode) {

                        this.documentIntelligenceProviderSettings.fieldProviders[field].parentPath = modifiedFieldSettingsForCode.parentPath;
                        this.documentIntelligenceProviderSettings.fieldProviders[field].index = modifiedFieldSettingsForCode.index;
                        this.documentIntelligenceProviderSettings.fieldProviders[field].childPath = modifiedFieldSettingsForCode.childPath;
                        this.documentIntelligenceProviderSettings.fieldProviders[field].resultPath = modifiedFieldSettingsForCode.resultPath;

                        overwrite = true;
                    }
                }

                if (!overwrite) {
                    let obj = {
                        fieldCode: modifiedFieldSettingsForCode.fieldCode,
                        parentPath: modifiedFieldSettingsForCode.parentPath,
                        index: modifiedFieldSettingsForCode.index,
                        childPath: modifiedFieldSettingsForCode.childPath,
                        resultPath: modifiedFieldSettingsForCode.resultPath
                    }

                    this.documentIntelligenceProviderSettings.fieldProviders.push(obj)
                }
            }
        },
        async getSettingsById(settingID) {
            DocumentIntelligenceProvidersService.getDocumentIntelligenceSettings(settingID)
                .then((data) => {
                    this.documentIntelligenceProviderSettings = data;
                    this.prebuiltModelID = data.configJSON
                    this.getModelFields().then(() => {
                        this.createConfigObject(data);
                    });
                })
        },
        createConfigObject(config) {
            for (let item of config.fieldProviders) {
                let rebuildDocSettings = {
                    fieldCode: item.fieldCode,
                    index: item.index,
                    parentPath: item.parentPath,
                    childPath: item.childPath,
                    resultPath: item.resultPath
                };

                this.configObject.push(rebuildDocSettings);
            }
        }
    },
};
</script>
